
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.819 13.875a4.893 4.893 0 01-4.069 4.069M6.75 6.13c-1.444 2.176-2.625 4.67-2.625 6.995a7.875 7.875 0 0015.75 0c0-4.875-3.375-8.625-6.113-11.354L10.5 8.625 6.75 6.13z","stroke":"#EDC843","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    